/**
 * populateSettings — creates the "#populated" sentinel and system objects.
 *
 * V1 reference: populateSettings.ts created #populated, #inbox, #anyday.
 * V2: #inbox and #anyday are virtual paths — no DB objects needed.
 * Only the #populated sentinel is created.
 */

import { db } from "@/db/schema"
import { now } from "@/shared/utils/date/dateUtils"

/**
 * Create the #populated sentinel setting.
 * This marks the database as initialized so populate() doesn't run again.
 */
export async function populateSettings(): Promise<void> {
  await db.setting.add({
    id: "#populated",
    value: "true",
    device: "system",
    createdAt: now(),
    createdBy: "system",
  })
}
